import {connect} from 'react-redux';
import Guide from '../components/Guide';
import {getGuideDownloadLinks} from "../selectors";

export default connect(
    (state) => ({
        localConfigurator: state.configurator.localConfigurator,
        guideDownloadLinks: getGuideDownloadLinks(state)
    }), null
)(Guide);